// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 종목 시세 차트 팝업 */

.scp-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scp-panel {
  background: #fff;
  border-radius: 12px;
  width: 820px;
  max-width: 92vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.22);
}

/* 모바일: bottom sheet */
@media (max-width: 768px) {
  .scp-overlay {
    align-items: flex-end;
  }
  .scp-panel {
    width: 100%;
    max-width: 100%;
    max-height: 92vh;
    border-radius: 16px 16px 0 0;
  }
}

/* ── 헤더 ── */
.scp-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 14px 16px 10px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
  gap: 12px;
}

.scp-title-block {
  flex: 1 1;
  min-width: 0;
}

.scp-title {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

.scp-stock-name {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
}

.scp-ticker {
  font-size: 11px;
  color: #999;
  font-family: monospace;
}

.scp-account-sub {
  margin-top: 3px;
  font-size: 12px;
  color: #aaa;
}

.scp-header-right {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}

.scp-current-price-block {
  text-align: right;
}

.scp-current-price {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
}

.scp-diff-rate {
  display: block;
  font-size: 12px;
  margin-top: 1px;
}

.scp-close {
  background: none;
  border: none;
  font-size: 17px;
  cursor: pointer;
  color: #aaa;
  padding: 4px 6px;
  line-height: 1;
  border-radius: 4px;
  flex-shrink: 0;
}

.scp-close:hover {
  color: #444;
  background: #f0f0f0;
}

/* ── 기간 선택 ── */
.scp-period-bar {
  display: flex;
  gap: 5px;
  padding: 8px 16px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.scp-period-btn {
  padding: 3px 12px;
  border: 1px solid #ddd;
  border-radius: 12px;
  background: #fff;
  font-size: 12px;
  cursor: pointer;
  color: #666;
  transition: all 0.12s;
}

.scp-period-btn.active {
  background: #4a6cf7;
  border-color: #4a6cf7;
  color: #fff;
}

.scp-period-btn:hover:not(.active) {
  border-color: #4a6cf7;
  color: #4a6cf7;
}

/* ── 스크롤 본문 ── */
.scp-body {
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
}

/* ── 차트 영역 ── */
.scp-chart-wrap {
  position: relative;
  min-height: 340px;
}

.scp-center {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #aaa;
}

/* ── 범례 ── */
.scp-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 18px;
  padding: 8px 16px 12px;
  border-top: 1px solid #f4f4f4;
  font-size: 12px;
  color: #555;
}

.scp-legend-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.scp-legend-line {
  display: inline-block;
  width: 22px;
  height: 2px;
  background: #4a6cf7;
  flex-shrink: 0;
}

.scp-legend-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* ── 차수 요약 테이블 ── */
.scp-turn-table-wrap {
  margin: 0 16px 16px;
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
}

.scp-turn-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.scp-turn-table th {
  background: #f4f6fb;
  padding: 8px 12px;
  font-size: 11px;
  font-weight: 700;
  color: #3a4cad;
  border-bottom: 1.5px solid #e8ecf8;
  white-space: nowrap;
}

.scp-turn-table td {
  padding: 9px 12px;
  border-bottom: 0.5px solid #f4f4f4;
  white-space: nowrap;
  color: #1a1a2e;
}

.scp-turn-table tbody tr:last-child td {
  border-bottom: none;
}

.scp-turn-table tbody tr:hover {
  background: #fafbff;
}

/* ── 종목명 클릭 링크 (여러 화면에서 공통 사용) ── */
.stock-chart-link {
  color: #e67e22;
  cursor: pointer;
}

.stock-chart-link:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/StockChartPopup.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE;IACE,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,4BAA4B;EAC9B;AACF;;AAEA,aAAa;AACb;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;EACd,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA,aAAa;AACb;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* 종목 시세 차트 팝업 */\n\n.scp-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  z-index: 9000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.scp-panel {\n  background: #fff;\n  border-radius: 12px;\n  width: 820px;\n  max-width: 92vw;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.22);\n}\n\n/* 모바일: bottom sheet */\n@media (max-width: 768px) {\n  .scp-overlay {\n    align-items: flex-end;\n  }\n  .scp-panel {\n    width: 100%;\n    max-width: 100%;\n    max-height: 92vh;\n    border-radius: 16px 16px 0 0;\n  }\n}\n\n/* ── 헤더 ── */\n.scp-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 14px 16px 10px;\n  border-bottom: 1px solid #eee;\n  flex-shrink: 0;\n  gap: 12px;\n}\n\n.scp-title-block {\n  flex: 1;\n  min-width: 0;\n}\n\n.scp-title {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.scp-stock-name {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1a1a2e;\n}\n\n.scp-ticker {\n  font-size: 11px;\n  color: #999;\n  font-family: monospace;\n}\n\n.scp-account-sub {\n  margin-top: 3px;\n  font-size: 12px;\n  color: #aaa;\n}\n\n.scp-header-right {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-shrink: 0;\n}\n\n.scp-current-price-block {\n  text-align: right;\n}\n\n.scp-current-price {\n  display: block;\n  font-size: 16px;\n  font-weight: 700;\n  color: #1a1a2e;\n}\n\n.scp-diff-rate {\n  display: block;\n  font-size: 12px;\n  margin-top: 1px;\n}\n\n.scp-close {\n  background: none;\n  border: none;\n  font-size: 17px;\n  cursor: pointer;\n  color: #aaa;\n  padding: 4px 6px;\n  line-height: 1;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n.scp-close:hover {\n  color: #444;\n  background: #f0f0f0;\n}\n\n/* ── 기간 선택 ── */\n.scp-period-bar {\n  display: flex;\n  gap: 5px;\n  padding: 8px 16px;\n  border-bottom: 1px solid #f0f0f0;\n  flex-shrink: 0;\n}\n\n.scp-period-btn {\n  padding: 3px 12px;\n  border: 1px solid #ddd;\n  border-radius: 12px;\n  background: #fff;\n  font-size: 12px;\n  cursor: pointer;\n  color: #666;\n  transition: all 0.12s;\n}\n\n.scp-period-btn.active {\n  background: #4a6cf7;\n  border-color: #4a6cf7;\n  color: #fff;\n}\n\n.scp-period-btn:hover:not(.active) {\n  border-color: #4a6cf7;\n  color: #4a6cf7;\n}\n\n/* ── 스크롤 본문 ── */\n.scp-body {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n/* ── 차트 영역 ── */\n.scp-chart-wrap {\n  position: relative;\n  min-height: 340px;\n}\n\n.scp-center {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  color: #aaa;\n}\n\n/* ── 범례 ── */\n.scp-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 18px;\n  padding: 8px 16px 12px;\n  border-top: 1px solid #f4f4f4;\n  font-size: 12px;\n  color: #555;\n}\n\n.scp-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.scp-legend-line {\n  display: inline-block;\n  width: 22px;\n  height: 2px;\n  background: #4a6cf7;\n  flex-shrink: 0;\n}\n\n.scp-legend-dot {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n/* ── 차수 요약 테이블 ── */\n.scp-turn-table-wrap {\n  margin: 0 16px 16px;\n  border: 1px solid #eee;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.scp-turn-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.scp-turn-table th {\n  background: #f4f6fb;\n  padding: 8px 12px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #3a4cad;\n  border-bottom: 1.5px solid #e8ecf8;\n  white-space: nowrap;\n}\n\n.scp-turn-table td {\n  padding: 9px 12px;\n  border-bottom: 0.5px solid #f4f4f4;\n  white-space: nowrap;\n  color: #1a1a2e;\n}\n\n.scp-turn-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.scp-turn-table tbody tr:hover {\n  background: #fafbff;\n}\n\n/* ── 종목명 클릭 링크 (여러 화면에서 공통 사용) ── */\n.stock-chart-link {\n  color: #e67e22;\n  cursor: pointer;\n}\n\n.stock-chart-link:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
